import { render, staticRenderFns } from "./child_similarProducts.vue?vue&type=template&id=63fe8941"
import script from "./child_similarProducts.vue?vue&type=script&lang=js"
export * from "./child_similarProducts.vue?vue&type=script&lang=js"
import style0 from "./child_similarProducts.vue?vue&type=style&index=0&id=63fe8941&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports